import styled from "styled-components";

export const Button = styled.button<{
  isActive?: boolean;
}>`
  --br: var(--root-br);
  overflow: hidden;
  position: relative;
  box-shadow: none;
  display: inline-flex;
  user-select: none;
  justify-content: center;
  align-items: center;
  margin: 0;
  font-size: 14px;
  text-decoration: none;
  padding: 8px 10px;
  vertical-align: middle;
  outline: none;
  font-weight: 500;
  color: ${({ isActive }) =>
    isActive ? "var(--color-cta)" : "var(--font-color-main)"};
`;

export const Group = styled.div.attrs({
  role: "group",
})`
  display: inline-flex;
`;
